import React from 'react';
import { connect } from 'react-redux';

const RegistrationConsole = (props) => {
  return (
    <div tabIndex="-1" className="Console">
      <span tabIndex="-1" className="Console-vehicleType">{props.selectedVehicleType ? props.selectedVehicleType.split('/').pop() : ''}</span>
      <span tabIndex="-1" className="Console-text" id="whichchosen">{props.text}</span>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    text: state.registration.registrationConsole,
    selectedVehicleType: state.registration.selectedVehicleType,
  };
};

export default connect(mapStateToProps)(RegistrationConsole);



// WEBPACK FOOTER //
// ./src/containers/registration/RegistrationConsole.js